import type { ThemeVariantMap } from "@/theme/types";

import { apolloCinemaLTDarkTheme } from "./apollocinema.LT.dark";
import { apolloCinemaLTLightTheme } from "./apollocinema.LT.light";

export const apollocinemaLT: ThemeVariantMap = {
  DARK: apolloCinemaLTDarkTheme,
  LIGHT: apolloCinemaLTLightTheme,
} as const;
